<template>
  <b-card-code title="لیست نوزادان ">


    <!--    <div class=" d-flex justify-content-start">-->
    <!--      <b-form-group>-->
    <!--        <div class="d-flex align-items-center">-->
    <!--          <b-button-->
    <!--              v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
    <!--              variant="success"-->
    <!--              :to="{ name: 'library-add'}"-->
    <!--          >-->
    <!--            ثبت کتاب جدید-->
    <!--          </b-button>-->
    <!--        </div>-->
    <!--      </b-form-group>-->
    <!--    </div>-->
    <!-- search input -->
    <div class="custom-search  justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">جستوجو</label>
          <b-form-input
              v-model="searchTerm"
              type="text"
              class="d-inline-block"
              @change="getbabyUser(currentPage)"
          />
        </div>
      </b-form-group>
    </div>

    <!--    <div class="custom-search  justify-content-end">-->
    <!--      <b-form-group-->
    <!--          label="انتخاب دسته محتوا (اجباری)"-->
    <!--          label-for="mother-categories"-->
    <!--      >-->
    <!--        <b-form-select-->
    <!--            id="mother-categories"-->
    <!--            v-model="categoryID"-->
    <!--            :options="categories"-->
    <!--            @change="getBooks(1)"-->

    <!--        />-->
    <!--      </b-form-group>-->
    <!--    </div>-->


    <!-- table -->
    <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
        :select-options="{
        enabled: false,
        selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
        :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >


      <template
          slot="table-row"
          slot-scope="props"
      >

        <!-- Column: Name -->
        <span
            v-if="props.column.field === 'fullName'"
            class="text-nowrap"
        >
          <b-avatar
              :src="props.row.avatar"
              class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.fullName }}</span>
        </span>

        <!--        &lt;!&ndash; Column: Status &ndash;&gt;-->
        <!--        <span v-else-if="props.column.field === 'status'">-->
        <!--          <b-badge :variant="statusVariant(props.row.status)">-->
        <!--            {{ props.row.status }}-->
        <!--          </b-badge>-->
        <!--        </span>-->

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>

             <b-button variant="info" class="ml-1"
                                   :to="{ name: 'calendar-babyInfo-list', params: { id: props.row.id ,unit : 1} }">
                              <feather-icon
                                  icon="InfoIcon"
                                  class="mr-50"
                              />
                                          <span>مشخصات قد</span>
                          </b-button>

                         <b-button variant="info" class="ml-1"
                                   :to="{ name: 'calendar-babyInfo-list', params: { id: props.row.id , unit : 2} }">
                              <feather-icon
                                  icon="InfoIcon"
                                  class="mr-50"
                              />
                                          <span>مشخصات وزن</span>
                          </b-button>

                         <b-button variant="info" class="ml-1"
                                   :to="{ name: 'calendar-babyInfo-list', params: { id: props.row.id ,unit : 3} }">
                              <feather-icon
                                  icon="InfoIcon"
                                  class="mr-50"
                              />
                                          <span>مشخصات دور سر</span>
                          </b-button>

<!--            <b-button variant="danger" class="ml-1" @click="deleteSubscription(props.row.id)">-->
<!--                   <feather-icon-->
<!--                       icon="TrashIcon"-->
<!--                       class="mr-50"-->

<!--                   />-->
<!--                <span>حذف</span>-->
<!--            </b-button>-->


          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
          slot="pagination-bottom"
          slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              نمایش  {{ pageLength }} از
            </span>
            <b-form-select
                v-model="pageLength"
                :options="['30','50','70']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                @change="getbabyUser(currentPage)"

            />
            <span class="text-nowrap"> از {{ totalRecords }} ورودی </span>
          </div>
          <div>
            <b-pagination
                :value="1"
                :total-rows="totalRecords"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                v-model="currentPage"
                class="mt-1 mb-0"
                @input="(value)=>getbabyUser(currentPage)"
            >
              <!--              <template #prev-text>-->
              <!--                <feather-icon-->
              <!--                    icon="ChevronLeftIcon"-->
              <!--                    size="18"-->
              <!--                />-->
              <!--              </template>-->
              <!--              <template #next-text>-->
              <!--                <feather-icon-->
              <!--                    icon="ChevronRightIcon"-->
              <!--                    size="18"-->
              <!--                />-->
              <!--              </template>-->
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

  </b-card-code>


</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar, BBadge, BPagination, BFormGroup, BButton, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import contentRepository from '@/modules/contents/services/contentRepository'
import { $themeConfig } from '@themeConfig'
import router from '@/router'
import Swal from 'sweetalert2'
import subscriptionRepository from '@/modules/subscriptions/services/subscriptionRepository'
import discountRepository from '@/modules/discount/services/discountRepository'
import libraryRepository from '@/modules/library/services/libraryRepository'
import { $appConfig } from '../../../../appConfig'
import categoryRepository from '@/modules/categories/services/categoryRepository'
import moment from 'jalali-moment'
import pregnancyCalendarsRepository from '@/modules/calender/services/pregnancyCalendarsRepository'

export default {
  name: 'listSubscriptions',
  components: {
    BCardCode,
    VueGoodTable,
    BAvatar,
    BBadge,
    BButton,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      pageLength: 30,
      currentPage: 1,
      totalRecords: 0,
      pageCount: 0,
      categoryID: 0,
      categories: [],
      dir: false,
      columns: [
        {
          label: 'نام و نام خانوادگی ',
          field: 'fullName',
        },
        {
          label: 'نام ولی ',
          field: 'parentFirstName',
        },
        {
          label: 'نام خانوادگی ولی ',
          field: 'parentLastName',
        },
        // {
        //   label: 'تلفن تماس مادر ',
        //   field: 'ص',
        // },
        {
          label: 'جنسیت ',
          field: 'gender',
        },
        {
          label: 'تاریخ تولد ',
          field: 'birthDate',
        },
        {
          label: 'سن ',
          field: 'age',
        },
        {
          label: 'دستورات',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      status: [{
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
        {
          1: 'light-primary',
          2: 'light-success',
          3: 'light-danger',
          4: 'light-warning',
          5: 'light-info',
        }],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  async created() {
    await this.getbabyUser(1)
  },
  methods: {
    async getbabyUser(pageNo) {
      let query = {
        pageNo: pageNo,
        pageSize: this.pageLength,
        key : this.searchTerm
      };

      const { data } = await pregnancyCalendarsRepository.getBabyUser(query)

      if (data.isSuccess) {


        this.rows = data.data.children.map((p) => {

          let date = ''
          let age = moment().diff(p.child.birthDate,'years')  ;
          date = age + '  سال  '

          if (age < 1){
            console.log(age , 'months')
            age = moment().diff(p.child.birthDate,'months')
            date = moment().diff(p.child.birthDate,'months') + ' ماه '
          }

          if (age < 1){
            console.log(age , 'days')

            age = moment().diff(p.child.birthDate,'days')
            date = moment().diff(p.child.birthDate,'days') + ' روز '
          }

          if (age < 1){
            console.log(age , 'hours')
            age = moment().diff(p.child.birthDate,'hours') ;
            date = moment().diff(p.child.birthDate,'hours') + ' ساعت '
          }

          if (age < 1){
            console.log(age , 'seconds')
            age = moment().diff(p.child.birthDate,'seconds')
            date = moment().diff(p.child.birthDate,'seconds') + ' ثانیه '
          }

          return {
            id: p.child.id,
            avatar: $appConfig.endpoint.baseFileDomain + '/' + p.child.avatar,
            parentId: p.parentId,
            parentFirstName: p.parentFirstName,
            parentLastName: p.parentLastName,
            fullName: p.child.fullName,
            birthDate:  p.child.birthDate ? moment(new Date(p.child.birthDate)).locale('fa').format('  YYYY/M/D') :'-',
            age:  date,
            gender: p.child.gender === 1 ? 'پسر' : p.child.gender === 2? 'دختر' : '-',
          }

        })
        this.totalRecords = data.data.totalRecordCount
        console.log(this.rows)
      }
    },
    deleteSubscription(id) {

      Swal.fire({
        title: 'آیا از حذف مطمئن هستید؟',
        showDenyButton: true,
        confirmButtonText: 'بله',
        denyButtonText: `خیر`,
        icon: 'info'
      })
          .then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              let query = `/${id}`
              const { data } = await libraryRepository.delete(query)

              if (data.isSuccess) {
                await Swal.fire('انجام شد', '', 'success')
                await this.getBooks(1)

              } else {
                await Swal.fire('هشدار', data.message, 'warning')
              }

            } else if (result.isDenied) {
            }
          })

      console.log(id)
    },
    async getCategories() {
      const { data } = await categoryRepository.get('')
      if (data.isSuccess) {
        let cats = data.data.map(p => {
          return {
            value: p.id,
            text: p.title
          }
        })
        cats.forEach(p => {
          this.categories.push(p)
        })
      }
    },
    gotoAdd() {
      router.push('/library/add')
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';


</style>
